import React from 'react';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { message, Modal } from 'antd';
import moment from 'moment';
import CustomBadge from 'components/CustomBadge';

// BrowserId 标识同一浏览器配置；PageInstanceId 标识本次页面加载，可用于区分标签页/刷新。
const createInvoiceDiagnosticId = () => {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).substring(2)}-${Math.random().toString(36).substring(2)}`;
};

const invoicePageInstanceId = createInvoiceDiagnosticId();

const getInvoiceBrowserId = () => {
  const storageKey = 'hyperflo-browser-id';
  let browserId = localStorage.getItem(storageKey);
  if (!browserId) {
    browserId = createInvoiceDiagnosticId();
    localStorage.setItem(storageKey, browserId);
  }
  return browserId;
};

const getInvoiceTabSessionId = () => {
  const storageKey = 'hyperflo-tab-session-id';
  let tabSessionId = sessionStorage.getItem(storageKey);
  if (!tabSessionId) {
    tabSessionId = createInvoiceDiagnosticId();
    sessionStorage.setItem(storageKey, tabSessionId);
  }
  return tabSessionId;
};

//弹出mailmerge的div
export function docMergeInvoice({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ mailMergeTemplateShow: true, mailMergeObjId: parameter.InvoiceId, mailMergeObj: parameter, dataModelType: 4 });
  setTimeout(() => {
    pageComponent.mailMergeTemplate.current?.getMailMergeTemplate(4, parameter.InvoiceId);
  }, config.setTimeoutMilliSecond);
}

//通过 Status 更换icon
export function formatData({ parameter, sectionComponent, pageComponent } = {}) {
  const moduleConfig = pageComponent?.state?.jobData?.ModuleConfig;
  // 必须所有发票的两个金额都有值，才可整组使用数据库金额；0 也是有效值。
  const useStoredAmounts = pageComponent?.props?.authUser?.Company?.DisbaleJobInvoiceAutoRefresh === true
    && Array.isArray(parameter)
    && parameter.every(item => item != null && item.AmountDue != null && item.AmountPaid != null);
  let accountingAppInvoiceIds = [];
  let data = parameter.map((item, i) => {
    setData(item, pageComponent, useStoredAmounts);
    if (item.AccountingAppInvoiceId !== null) {
      accountingAppInvoiceIds.push(item.AccountingAppInvoiceId);
    }
    return item;
  })

  calculateTotal(parameter, sectionComponent, pageComponent);

  //如果有绑定会计系统，开始查询相关数据
  if (moduleConfig?.AccountingAppIntegrationId != null) {
    if (useStoredAmounts) {
      setAccountingAppTitle(pageComponent, globalFunction.getSectionComponent(pageComponent, 'Invoice'));
      updateInvoiceNavigation(pageComponent, data.some(item => item?.Status === 1 && item.AmountDue > 0));
    } else {
      getAccountingApp(pageComponent, accountingAppInvoiceIds);
    }
  }
  return data;
}

function setData(item, pageComponent, useStoredAmounts = false) {
  let iconFormat = [];
  const paymentBalance = item.Balance;
  //AccountingApp设置成空待查询
  item.AccountingApp = null;
  if (item.Status === 1) {
    //如果 Status 是1, actionType 是 Approve 的 图标设置用第2个图片, 设置状态颜色
    iconFormat.push({ actionType: 'Approve', iconIndex: 1 });
    iconFormat.push({ actionType: 'Delete', iconIndex: 1, title: 'Create Credit Note' });
    // 已批准状态保持原有图标样式；approve 方法会按 Status 拦截，不会再次提交。
    item.ButtonFormat = [{ actionType: 'Delete', confirmText: 'Create credit note for this invoice' }];
    item.StatusBackgroundColor = config.color.success;

    if (pageComponent?.state?.jobData?.ModuleConfig?.AccountingAppIntegrationId != null) {
      if (useStoredAmounts) {
        item.AccountingApp = item.AmountDue > 0 ? globalFunction.formatMoney(item.AmountDue) : 'Paid';
        item.AccountingAppBackgroundColor = item.AmountDue > 0 ? config.color.danger : config.color.success;
        item.HasPayment = item.AmountPaid > 0;
      } else if (item.AccountingAppInvoiceId !== null && item.DueAmount !== null) {
        if (item.DueAmount > 0) {
          item.AccountingApp = globalFunction.formatMoney(item.DueAmount);
          item.AccountingAppBackgroundColor = config.color.danger;
        } else {
          // item.AccountingApp = 'Paid'.toUpperCase();
          // item.AccountingAppBackgroundColor = config.color.success;
        }
      }
    } else {
      if (item.Balance > 0) {
        item.Balance = globalFunction.formatMoney(item.Balance);
        item.BalanceBackgroundColor = config.color.danger;
      } else {
        item.Balance = 'Paid'.toUpperCase();
        item.BalanceBackgroundColor = config.color.success;
      }
      item.AccountingApp = item.Balance;
      item.AccountingAppBackgroundColor = item.BalanceBackgroundColor;
    }

    if (item.Total < 0) {
      item.AccountingApp = 'Paid'.toUpperCase();
      item.AccountingAppBackgroundColor = config.color.success;
    }

  } else {
    item.StatusBackgroundColor = config.color.default;
    item.Balance = null;
  }
  const companyId = pageComponent?.props?.authUser?.CompanyId;
  if (Number(companyId) === 61) {
    if (item.Status === 1 && paymentBalance != null && Number.isFinite(Number(paymentBalance))) {
      item.PaymentBalance = Number(paymentBalance) > 0
        ? globalFunction.formatMoney(Number(paymentBalance))
        : 'PAID';
      item.BalanceBackgroundColor = Number(paymentBalance) > 0 ? config.color.danger : config.color.success;
    } else {
      item.PaymentBalance = null;
    }
  }
  if (iconFormat.length > 0) item.IconFormat = iconFormat;
  if (item.CreditedBy !== null || item.Total < 0) {
    item.ButtonFormat = [{ actionType: 'Delete', disabled: true }];
    item.className = 'lightgray';
  }
}

export function calculateTotal(parameter, sectionComponent, pageComponent) {
  let total = 0;
  let data = parameter.map((item, i) => {
    total += item.Total;
  });

  // 判断公司设置 ShowProjectTotalFeeInvoice 是否启用
  let showProjectTotal = pageComponent?.props?.authUser?.Company?.ShowProjectTotalFeeInvoice;
  let jobData = pageComponent?.state?.jobData;

  if (showProjectTotal && jobData && jobData.JobNum && jobData.JobNum.includes('/')) {
    // 调用后端接口查询同 Project 下所有 Job 的 Invoice 总和（仅 Status=1）
    httpClient
      .get('Business/Invoice/GetProjectTotal?jobId=' + jobData.JobId)
      .then(({ data }) => {
        if (data.result) {
          let projectTotal = data.data;
          sectionComponent.props.parentComponent.setState({
            tableFooter: <div>
              <span>{'Total: ' + globalFunction.formatMoney(total)}</span>
              <span style={{ marginLeft: '30px' }}><CustomBadge text={'Project Total: ' + globalFunction.formatMoney(projectTotal)} backgroundColor="#03A9F4" /></span>
            </div>
          });
        }
      })
      .catch(() => {
        sectionComponent.props.parentComponent.setState({ tableFooter: 'Total: ' + globalFunction.formatMoney(total) });
      });
  } else {
    sectionComponent.props.parentComponent.setState({ tableFooter: 'Total: ' + globalFunction.formatMoney(total) });
  }
}

function setAccountingAppTitle(pageComponent, invoice) {
  const invoiceTable = invoice?.child?.current;
  const column = invoiceTable?.state?.columns?.find(item => item?.key === 'AccountingApp');
  const tenantName = pageComponent?.state?.jobData?.ModuleConfig?.AccountingAppIntegration?.TenantName;
  if (column != null && tenantName != null && (globalFunction.isNullOrEmpty(column.title) || column.title === 'Your Company')) {
    const replaceParameter = [{ targetKey: 'key', targetValue: 'AccountingApp', replaceKey: 'title', replaceValue: tenantName }];
    globalFunction.replaceUie({ tableComponent: invoiceTable, componentType: 'View', uieSource: 'AccountingApp', replaceParameter });
  }
}

function updateInvoiceNavigation(pageComponent, hasOutstandingAmount) {
  setTimeout(() => {
    const navigation = pageComponent?.sectionNavigation?.current;
    const page = navigation?.state?.page;
    page?.sectionList?.forEach(item => {
      if (item?.name === 'Invoice') {
        item.className = hasOutstandingAmount ? 'red red-border' : '';
      }
    });
    if (page != null) navigation?.setState({ page });
  }, 50);
}

export function getAccountingApp(pageComponent, accountingAppInvoiceIds) {
  let invoice = globalFunction.getSectionComponent(pageComponent, 'Invoice');
  if (invoice !== null) {
    invoice.child.current?.setState({ loaded: false });
    let newData = invoice.child.current?.state.data.map((invoiceItem, i) => {
      if (invoiceItem.Balance >= 0 && invoiceItem.AccountingAppInvoiceId !== null) {
        invoiceItem.AccountingApp = 'loading-icon';
      }
      return invoiceItem;
    })
    invoice.child.current?.setState({ loaded: true });
    let sectionData = pageComponent.state.sectionData;
    sectionData['Invoice'] = newData;
    pageComponent.setState({ sectionData });

    setAccountingAppTitle(pageComponent, invoice);

    httpClient
      .post('/Business/Invoice/GetInvoicesDueAmount', { appIntegrationId: pageComponent.state.jobData.ModuleConfig.AccountingAppIntegrationId, accountingAppInvoiceIds })
      .then(({ data }) => {
        if (data.data !== null) {
          let check = false;
          invoice.child.current?.setState({ loaded: false });
          let newData = invoice.child.current?.state.data.map((invoiceItem, i) => {
            data.data.map((accountingItem, j) => {
              if (accountingItem.AccountingAppInvoiceId === invoiceItem.AccountingAppInvoiceId) {
                invoiceItem.AccountingApp = accountingItem.DueAmount;
                invoiceItem.HasPayment = accountingItem.HasPayment;
                invoiceItem.OnlinePaymentList = accountingItem.PaymentList || [];
                switch (accountingItem.Status?.toLowerCase()) {
                  case 'paid':
                    //适应Xero
                    invoiceItem.AccountingApp = accountingItem.Status;
                    invoiceItem.AccountingAppBackgroundColor = config.color.success;
                    break;

                  case 'voided':
                  case 'deleted':
                    //同时适应Xero 和 Quickbooks
                    invoiceItem.AccountingApp = accountingItem.Status;
                    invoiceItem.AccountingAppBackgroundColor = config.color.inactive;
                    invoiceItem.ButtonFormat = [{ actionType: 'Delete', disabled: true }];
                    break;

                  default:
                    //同时适应Xero 和 Quickbooks
                    if (accountingItem.DueAmount > 0) {
                      invoiceItem.AccountingApp = globalFunction.formatMoney(accountingItem.DueAmount);
                      invoiceItem.AccountingAppBackgroundColor = config.color.danger;
                      check = true;
                    } else {
                      invoiceItem.AccountingApp = 'Paid';
                      invoiceItem.AccountingAppBackgroundColor = config.color.success;
                    }
                    break;
                }
              }
            })
            if (!globalFunction.isNullOrEmpty(pageComponent.state.jobData.ModuleConfig.AccountingAppIntegration.AppIntegrationTypeName) && invoiceItem.Status === 1 && invoiceItem.AccountingApp === null) {
              invoiceItem.AccountingApp = 'No ' + pageComponent.state.jobData.ModuleConfig.AccountingAppIntegration.AppIntegrationTypeName + ' ID';
            }
            return invoiceItem;
          })
          invoice.child.current?.setState({ loaded: true });
          let sectionData = pageComponent.state.sectionData;
          sectionData['Invoice'] = newData;
          pageComponent.setState({ sectionData });

          updateInvoiceNavigation(pageComponent, check);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

//CopyFrom 快速填写数据
export function copyFromJobContact({ sectionName, parameter, sectionComponent, pageComponent, uie }) {
  let date = sectionComponent.customForm.current?.formRef.current?.getFieldValue('Date').toDate();
  let addDays = pageComponent.props.authUser.Company.InvoiceDefaultDuedays;
  switch (pageComponent.state.jobData.ModuleConfig.CustomInvoiceTerm) {
    case 'Commercial job 21 days':
      if (pageComponent.state.jobData.JobTypeName == 'Commercial') {
        addDays = 21;
      }
      break;
    default:
      break;
  }
  if (parameter > 0) {
    httpClient
      .get('/Business/JobContact/' + parameter)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactFirstName', data.data.FirstName);
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactLastName', data.data.LastName);
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactCompany', data.data.Company);

          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactStreetNumber', data.data.StreetNumber);
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactStreetName', data.data.StreetName);
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactSuburb', data.data.Suburb);
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactState', data.data.State);
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactPostcode', data.data.Postcode);
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactCountry', data.data.Country);
          if (!globalFunction.isNullOrEmpty(data.data.Email)) {
            let email = data.data.Email.replace(/:/g, ",").split(',')[0];
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactEmail', email);
          } else {
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactEmail', data.data.Email);
          }
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactNumber', data.data.Mobile);
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('ContactTaxNumber', data.data.BusinessNo);

          if (sectionComponent.state.componentType == 'Create') {
            sectionComponent.setState({ invoiceToContactTypeName: data.data.ContactTypeName });
            if (!globalFunction.isNullOrEmpty(pageComponent.state.jobData.ClientUser?.Client?.InvoiceTerms) && data.data.ContactTypeName == 'Applicant') {
              if (pageComponent.state.jobData.ClientUser.Client.InvoiceTerms.toLowerCase() == 'eonm') {
                sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ DueDate: moment(globalFunction.getLastDayOfOneMonthsLater(date), config.format.date) });
              } else {
                addDays = parseInt(pageComponent.state.jobData.ClientUser.Client.InvoiceTerms);
                sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ DueDate: moment(globalFunction.addDate(date, addDays), config.format.date) });
              }
            } else {
              sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ DueDate: moment(globalFunction.addDate(date, addDays), config.format.date) });
            }
          }
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  } else {
    sectionComponent.setState({ invoiceToContactTypeName: '' });
    if (sectionComponent.state.componentType == 'Create') {
      sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ DueDate: moment(globalFunction.addDate(date, addDays), config.format.date) });
    }
  }
}

// 按 ModuleConfig.InvoiceDefaultContact 自动回填新增 Invoice 的联系人。
// 该钩子同时由 Invoice Add 和 ServiceRequest -> Invoice 两个入口复用。
function loadDefaultInvoiceContact(sectionComponent, pageComponent) {
  // 未配置规则时不发请求，避免每次打开新增表单产生无效查询。
  const defaultContactRule = pageComponent.state.jobData.ModuleConfig?.InvoiceDefaultContact;
  if (globalFunction.isNullOrEmpty(defaultContactRule)) return;
  const jobId = pageComponent.state.jobData.JobId;
  httpClient
    .get('/Business/Invoice/GetDefaultContact?jobId=' + jobId)
    .then(({ data }) => {
      if (!data.result) {
        globalFunction.handleResultError(data, pageComponent);
        return;
      }
      if (!data.data || sectionComponent.state.componentType !== 'Create') return;

      const contact = data.data;
      const email = !globalFunction.isNullOrEmpty(contact.ContactEmail)
        ? contact.ContactEmail.replace(/:/g, ',').split(',')[0]
        : contact.ContactEmail;
      sectionComponent.customForm.current?.formRef.current?.setFieldsValue({
        ContactFirstName: contact.ContactFirstName,
        ContactLastName: contact.ContactLastName,
        ContactCompany: contact.ContactCompany,
        ContactStreetNumber: contact.ContactStreetNumber,
        ContactStreetName: contact.ContactStreetName,
        ContactSuburb: contact.ContactSuburb,
        ContactState: contact.ContactState,
        ContactPostcode: contact.ContactPostcode,
        ContactCountry: contact.ContactCountry,
        ContactEmail: email,
        ContactNumber: contact.ContactNumber,
        ContactTaxNumber: contact.ContactTaxNumber,
      });
      sectionComponent.setState({ invoiceToContactTypeName: contact.ContactTypeName });

      // Applicant 继续沿用客户 InvoiceTerms；其他联系人沿用公司默认账期。
      const date = sectionComponent.customForm.current?.formRef.current?.getFieldValue('Date');
      if (!date) return;
      let addDays = pageComponent.props.authUser.Company.InvoiceDefaultDuedays;
      const invoiceTerms = pageComponent.state.jobData.ClientUser?.Client?.InvoiceTerms;
      if ((contact.ContactTypeName || '').toLowerCase() === 'applicant' && !globalFunction.isNullOrEmpty(invoiceTerms)) {
        if (invoiceTerms.toLowerCase() === 'eonm') {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', moment(globalFunction.getLastDayOfOneMonthsLater(date.toDate()), config.format.date));
        } else {
          addDays = parseInt(invoiceTerms);
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', moment(globalFunction.addDate(date.toDate(), addDays), config.format.date));
        }
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//----------------- Copy From Xero -----------------//
//防抖参数: 输入≥3个字符且停顿1秒后才查询 Xero (Xero API 有调用配额, 从严于全局的 minimumQueryCharacters)
const XERO_SEARCH_MIN_CHARS = 3;
const XERO_SEARCH_DEBOUNCE_MS = 1000;
let xeroSearchTimer = null;          //模块级防抖 timer
let xeroContactJustSelected = false; //选中某项后 antd 会再触发一次 onChange, 用此标记跳过, 避免多余的 Xero 查询

//CopyFromXero: AutoComplete 输入时(onChange)防抖查询 Xero 联系人
export function searchXeroContactChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  //每次输入先取消上一次未触发的查询
  if (xeroSearchTimer) {
    clearTimeout(xeroSearchTimer);
    xeroSearchTimer = null;
  }
  //刚选中某项时触发的 onChange, 不发起查询
  if (xeroContactJustSelected) {
    xeroContactJustSelected = false;
    return;
  }
  //少于3个字符不查询, 节约 Xero API 调用次数
  if (globalFunction.isNullOrEmpty(parameter) || parameter.trim().length < XERO_SEARCH_MIN_CHARS) {
    return;
  }
  let keyword = parameter.trim();
  //停止输入1秒后才发起查询(防抖)
  xeroSearchTimer = setTimeout(() => {
    xeroSearchTimer = null;
    httpClient
      .get(uie.datasourceUrl + '?keyword=' + encodeURIComponent(keyword) + '&jobId=' + pageComponent.state.jobData.JobId)
      .then(({ data }) => {
        if (data.result) {
          //映射成 AutoComplete 需要的 {label, value, data} 结构, data 里是后端一次带回的全部回填字段
          let options = data.data.map((item) => ({ label: item.Key, value: item.Value, data: item.Data }));
          let componentDataSource = { ...formComponent.state.componentDataSource };
          componentDataSource[uie.source] = options;
          formComponent.setState({ componentDataSource });
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, XERO_SEARCH_DEBOUNCE_MS);
}

//CopyFromXero: 选中(onSelect)后回填 Invoice To 联系人字段(数据搜索时已带回, 无需二次请求)
export function copyFromXero({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  //取消未触发的防抖查询, 并标记跳过随之而来的 onChange
  if (xeroSearchTimer) {
    clearTimeout(xeroSearchTimer);
    xeroSearchTimer = null;
  }
  xeroContactJustSelected = true;
  let data = parameter.data;
  if (!data) return;
  formComponent.formRef.current?.setFieldValue('ContactFirstName', data.ContactFirstName);
  formComponent.formRef.current?.setFieldValue('ContactLastName', data.ContactLastName);
  formComponent.formRef.current?.setFieldValue('ContactCompany', data.ContactCompany);
  formComponent.formRef.current?.setFieldValue('ContactStreetNumber', data.ContactStreetNumber);
  formComponent.formRef.current?.setFieldValue('ContactStreetName', data.ContactStreetName);
  formComponent.formRef.current?.setFieldValue('ContactSuburb', data.ContactSuburb);
  formComponent.formRef.current?.setFieldValue('ContactState', data.ContactState);
  formComponent.formRef.current?.setFieldValue('ContactPostcode', data.ContactPostcode);
  formComponent.formRef.current?.setFieldValue('ContactCountry', data.ContactCountry);
  formComponent.formRef.current?.setFieldValue('ContactTaxNumber', data.ContactTaxNumber);
  formComponent.formRef.current?.setFieldValue('ContactEmail', data.ContactEmail);
  formComponent.formRef.current?.setFieldValue('ContactNumber', data.ContactNumber);
}

//弹出批准Invoice的UI
export function approve({ sectionName, parameter, sectionComponent, pageComponent, uie }) {
  if (parameter.Status === 0) {
    pageComponent.setState({ approveConfirmShow: true, invoice: parameter, updateInvoiceToday: true });
  }
}

//批准Invoice, 推送会计系统
export function runApprove({ jobId, invoiceId, updateInvoiceToday, pageComponent }) {
  let invoice = globalFunction.getSectionComponent(pageComponent, 'Invoice');
  const invoiceTable = invoice?.child?.current;
  const oldData = invoiceTable?.state?.data;
  if (!Array.isArray(oldData)) {
    message.error('Invoice data is not available. Please refresh the page and try again.');
    return Promise.resolve(false);
  }

  const originalItem = oldData.find(item => item?.key === invoiceId);
  if (originalItem == null) {
    message.error('Invoice was not found. Please refresh the page and try again.');
    return Promise.resolve(false);
  }

  // 保存提交前按钮状态；失败或网络异常时完整恢复，允许用户重新 Approve。
  const originalIconFormat = Array.isArray(originalItem.IconFormat)
    ? originalItem.IconFormat.map(item => ({ ...item }))
    : undefined;
  const originalButtonFormat = Array.isArray(originalItem.ButtonFormat)
    ? originalItem.ButtonFormat.map(item => ({ ...item }))
    : undefined;

  const updateApproveButtonState = ({ iconFormat, buttonFormat }) => {
    const currentData = invoiceTable?.state?.data;
    if (!Array.isArray(currentData)) return currentData;

    const updatedData = currentData.map(item => item?.key === invoiceId
      ? { ...item, IconFormat: iconFormat, ButtonFormat: buttonFormat }
      : item);
    invoiceTable.setState({ loaded: true, data: updatedData });
    return updatedData;
  };

  const loadingIconFormat = [
    ...(originalIconFormat ?? []).filter(item => item?.actionType !== 'Approve'),
    { actionType: 'Approve', iconIndex: 2 }
  ];
  const loadingButtonFormat = [
    ...(originalButtonFormat ?? []).filter(item => item?.actionType !== 'Approve'),
    { actionType: 'Approve', disabled: true }
  ];
  updateApproveButtonState({ iconFormat: loadingIconFormat, buttonFormat: loadingButtonFormat });


  // 返回 Promise，便于调用方(确认框)在请求完成后复位 loading/防双击状态
  // 每次批准生成独立 RequestId，并带上浏览器/页面实例标识，供后端 NLog 排查重复提交来源。
  const diagnosticHeaders = {
    'X-HyperFlo-Browser-Id': getInvoiceBrowserId(),
    'X-HyperFlo-Tab-Session-Id': getInvoiceTabSessionId(),
    'X-HyperFlo-Page-Instance-Id': invoicePageInstanceId,
    'X-HyperFlo-Request-Id': createInvoiceDiagnosticId(),
  };

  return httpClient
    .post('Business/Invoice/Approve', { jobId, invoiceId, updateInvoiceToday }, { headers: diagnosticHeaders })
    .then(({ data }) => {
      if (data?.result && data?.data != null) {
        let accountingAppInvoiceIds = [];
        const approvedInvoice = data.data;
        const approvedInvoiceKey = approvedInvoice.key ?? approvedInvoice.InvoiceId;
        if (approvedInvoiceKey == null) {
          updateApproveButtonState({
            iconFormat: originalIconFormat,
            buttonFormat: originalButtonFormat
          });
          message.error('Approved invoice data is incomplete. Please refresh the page and try again.');
          return;
        }

        setData(approvedInvoice, pageComponent);
        // 后端已确认成功后使用已批准图标；保持原有颜色，不设置 disabled。
        approvedInvoice.IconFormat = [
          ...(approvedInvoice.IconFormat ?? []).filter(item => item?.actionType !== 'Approve'),
          { actionType: 'Approve', iconIndex: 1 }
        ];
        const currentData = invoiceTable?.state?.data;
        if (!Array.isArray(currentData)) {
          message.error('Invoice data is not available. Please refresh the page.');
          return;
        }

        let newData = currentData.map((item, i) => {
          if (item.key === approvedInvoiceKey) {
            item = approvedInvoice;
            if (item.AccountingAppInvoiceId !== null) {
              accountingAppInvoiceIds.push(item.AccountingAppInvoiceId);
            }
          }
          return item;
        });
        invoiceTable?.setState({ loaded: true, data: newData });

        calculateTotal(newData, invoiceTable, pageComponent);

        if (data.data.Balance > 0) {
          pageComponent?.sectionNavigation?.current?.state?.page?.sectionList?.forEach(item => {
            if (item.name === 'Invoice') {
              item.className = 'red red-border';
            }
          });
          pageComponent?.setState({});
        }

        // //如果有绑定会计系统，开始查询相关数据
        // if (pageComponent.state.jobData.ModuleConfig.AccountingAppIntegrationId !== null) {
        //   getAccountingApp(pageComponent, accountingAppInvoiceIds);
        // }
      } else {
        Modal.error({
          title: 'Error',
          content: <span dangerouslySetInnerHTML={{ __html: data?.message?.replace(/\n/g, '<br />') ?? 'Failed to approve invoice.' }}></span>,
          transitionName: "",
          maskTransitionName: "",
        });

        updateApproveButtonState({
          iconFormat: originalIconFormat,
          buttonFormat: originalButtonFormat
        });
      }
    })
    .catch(function (error) {
      // 网络或运行时异常同样恢复按钮，避免 Invoice 永久停留在 loading/disabled 状态。
      updateApproveButtonState({
        iconFormat: originalIconFormat,
        buttonFormat: originalButtonFormat
      });
      globalFunction.handleError(error, pageComponent);
    });
}

//分情况是删除还是对冲
export function deleteBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (parameter.AccountingAppInvoiceId === null) {
    if (parameter.Status === 0) {
      //没有关联会计系统且没被批准, 可以删除
      httpClient
        .delete(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
        .then(({ data }) => {
          if (data.result) {
            // sectionComponent.getSectionDataByDefault();
            let invoice = globalFunction.getSectionComponent(pageComponent, 'Invoice');
            let oldData = invoice.child.current?.state.data;
            oldData.splice(oldData.findIndex(item => item.key === parameter.key), 1);
            invoice.child.current?.setState({ loaded: false });
            invoice.child.current?.setState({ loaded: true, data: oldData });
            calculateTotal(oldData, sectionComponent.child.current, pageComponent);
          } else {
            message.error(data.message);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    }
  } else {
    //会计系统对冲或其他操作
    let invoice = globalFunction.getSectionComponent(pageComponent, 'Invoice');
    let oldData = invoice.child.current?.state.data;
    let newData = oldData.map((item, i) => {
      if (item.key === parameter.InvoiceId) {
        item.IconFormat = item.IconFormat.map(iconFormat => {
          if (iconFormat.actionType === 'Delete') {
            return { ...iconFormat, iconIndex: 2 };
          }
          return iconFormat;
        });
      }
      return item;
    })
    setTimeout(() => {
      invoice.child.current?.setState({ loaded: false });
      invoice.child.current?.setState({ loaded: true, data: newData });
    }, config.setTimeoutMilliSecond);

    httpClient
      .post(pageComponent.props.areaName + '/' + sectionName + '/CreditNote/', { InvoiceId: parameter.InvoiceId, JobId: parameter.JobId })
      .then(({ data }) => {
        if (data.result) {
          let creditNote = data.data;
          creditNote.IconFormat = [{ actionType: 'Approve', iconIndex: 1 }, { actionType: 'Delete', iconIndex: 1 }];
          oldData.push(data.data);
          let newData = oldData.map((item, i) => {
            if (item.key === parameter.InvoiceId || item.key === data.data.InvoiceId) {
              item.AccountingApp = 'Paid'.toUpperCase();
              item.AccountingAppBackgroundColor = config.color.success;
              item.StatusBackgroundColor = config.color.success;
              item.IconFormat = item.IconFormat.map(iconFormat => {
                if (iconFormat.actionType === 'Delete') {
                  return { ...iconFormat, iconIndex: 1 };
                }
                return iconFormat;
              });

              item.ButtonFormat = [{ actionType: 'Delete', disabled: true }];
            }
            return item;
          })
          calculateTotal(newData, sectionComponent.child.current, pageComponent);
          invoice.child.current?.setState({ loaded: false });
          invoice.child.current?.setState({ loaded: true, data: newData });
        } else {
          message.error(data.message);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }
}

export function refreshInvoiceData({ data, parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let oldData = sectionComponent.child.current?.state.data;
  switch (sectionComponent.state.componentType) {
    case 'Create':
      oldData.push(data);
      calculateTotal(oldData, sectionComponent.child.current, pageComponent);
      break;
    case 'Edit':
      let accountingAppInvoiceIds = [];
      oldData = oldData.map((item, i) => {
        if (item.key === data.key) {
          item = data;
          setData(item, pageComponent);
          if (item.AccountingAppInvoiceId !== null) {
            accountingAppInvoiceIds.push(item.AccountingAppInvoiceId);
          }
        }
        return item;
      })

      calculateTotal(oldData, sectionComponent.child.current, pageComponent);

      // //如果有绑定会计系统，开始查询相关数据
      // if (pageComponent.state.jobData.ModuleConfig.AccountingAppIntegrationId !== null) {
      //   getAccountingApp(pageComponent, accountingAppInvoiceIds);
      // }
      break;
  }
  sectionComponent.child.current?.setState({ loaded: false });
  sectionComponent.child.current?.setState({ loaded: true, data: oldData });
  globalFunction.getSectionComponent(pageComponent, 'Quote')?.getSectionDataByDefault();
}

//Date 和 DueDate 设置添加时的默认值
export function addInvoicePopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let lineItemForm = sectionComponent.customForm.current?.additionalFormRef.current?.child.current;
  lineItemForm?.addLineItem(true);
  let addDays = pageComponent.props.authUser.Company.InvoiceDefaultDuedays;
  switch (pageComponent.state.jobData.ModuleConfig.CustomInvoiceTerm) {
    case 'Commercial job 21 days':
      if (pageComponent.state.jobData.JobTypeName == 'Commercial') {
        addDays = 21;
      }
      break;
    default:
      break;
  }
  if (!globalFunction.isNullOrEmpty(pageComponent.state.jobData.ClientUser?.Client?.InvoiceTerms) && sectionComponent.state.invoiceToContactTypeName == 'Applicant') {
    if (pageComponent.state.jobData.ClientUser.Client.InvoiceTerms.toLowerCase() == 'eonm') {
      sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ Date: moment(new Date(), config.format.date), DueDate: moment(globalFunction.getLastDayOfOneMonthsLater(new Date()), config.format.date) });
    } else {
      addDays = parseInt(pageComponent.state.jobData.ClientUser.Client.InvoiceTerms);
      sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ Date: moment(new Date(), config.format.date), DueDate: moment(globalFunction.addDate(new Date(), addDays), config.format.date) });
    }
  } else {
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ Date: moment(new Date(), config.format.date), DueDate: moment(globalFunction.addDate(new Date(), addDays), config.format.date) });
  }
  let JobContact = globalFunction.getSectionComponent(pageComponent, 'JobContact');
  let CopyFrom = [{ Key: "- Select Job Contact -", Value: 0 }]
  JobContact.child.current?.state.data.map(data => {
    CopyFrom.push({ Key: data.ContactTypeName + ' - ' + data.FullNameCompany, Value: data.JobContactId });
  });
  let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
  componentDataSource['CopyFrom'] = CopyFrom;
  pageComponent.setState({ addFromQuoteId: null });
  loadDefaultInvoiceContact(sectionComponent, pageComponent);
}

export function dateOnChange({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let addDays = pageComponent.props.authUser.Company.InvoiceDefaultDuedays;
  switch (pageComponent.state.jobData.ModuleConfig.CustomInvoiceTerm) {
    case 'Commercial job 21 days':
      if (pageComponent.state.jobData.JobTypeName == 'Commercial') {
        addDays = 21;
      }
      break;
    default:
      break;
  }
  switch (sectionComponent.state.invoiceToContactTypeName) {
    case 'Applicant':
      if (!globalFunction.isNullOrEmpty(pageComponent.state.jobData.ClientUser?.Client?.InvoiceTerms)) {
        if (pageComponent.state.jobData.ClientUser.Client.InvoiceTerms.toLowerCase() == 'eonm') {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', moment(globalFunction.getLastDayOfOneMonthsLater(parameter.toDate()), config.format.date));
        } else {
          addDays = parseInt(pageComponent.state.jobData.ClientUser.Client.InvoiceTerms);
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', moment(globalFunction.addDate(parameter.toDate(), addDays), config.format.date));
        }
      } else {
        sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', moment(globalFunction.addDate(parameter.toDate(), addDays), config.format.date));
      }
      break;
    default:
      switch (sectionComponent.state.componentType) {
        case 'Create':
          if (!globalFunction.isNullOrEmpty(pageComponent.state.jobData.ClientUser?.Client?.InvoiceTerms) && sectionComponent.state.invoiceToContactTypeName == 'Applicant') {
            if (pageComponent.state.jobData.ClientUser.Client.InvoiceTerms.toLowerCase() == 'eonm') {
              sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', moment(globalFunction.getLastDayOfOneMonthsLater(parameter.toDate()), config.format.date));
            } else {
              addDays = parseInt(pageComponent.state.jobData.ClientUser.Client.InvoiceTerms);
              sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', moment(globalFunction.addDate(parameter.toDate(), addDays), config.format.date));
            }
          } else {
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', moment(globalFunction.addDate(parameter.toDate(), addDays), config.format.date));
          }
          break;
        case 'Edit':
          if (!globalFunction.isNullOrEmpty(pageComponent.state.jobData.ClientUser?.Client?.InvoiceTerms)) {
            if (pageComponent.state.jobData.ClientUser.Client.InvoiceTerms.toLowerCase() == 'eonm') {
              sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', moment(globalFunction.getLastDayOfOneMonthsLater(parameter.toDate()), config.format.date));
            } else {
              addDays = parseInt(pageComponent.state.jobData.ClientUser.Client.InvoiceTerms);
              sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', moment(globalFunction.addDate(parameter.toDate(), addDays), config.format.date));
            }
          } else {
            sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', moment(globalFunction.addDate(parameter.toDate(), addDays), config.format.date));
          }
          break;
      }
      break;
  }
}

export function editInvoiceContribution({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ editInvoiceContributionShow: true, invoice: parameter });
  setTimeout(() => {
    pageComponent.invoiceContribution.current?.initialization();
  }, config.setTimeoutMilliSecond);
}

export function collapseInvoice({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.current?.toggleAllRows();
}

//快速填充Due Date
export function quickAddDays_DueDate({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let date = sectionComponent.customForm.current?.formRef.current?.getFieldValue('Date');
  if (date !== undefined) {
    sectionComponent.customForm.current?.formRef.current?.setFieldValue('DueDate', globalFunction.addDateMoment(date, parameter));
  }
}
